import {getCookie, setCookie} from '../helpers/CookieHelper';

export class HsMiscComponent {
  constructor() {

  }

  initialize() {
    this.setPageTitles();

    this.addEventListeners();
  }

  setPageTitles() {
    setTimeout(() => {
      const titles = document.querySelectorAll('.hs-page_title input');
      Array.from(titles).forEach((title) => {
        title.value = THEME_CONFIG.page_title;
      });
    }, 2000);
  }

  addEventListeners() {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        this.makeUserKnown();
      }
    });
  }

  makeUserKnown() {
    if (getCookie('hs_is_known_user')) {
      return;
    }

    setCookie('hs_is_known_user', 1, 180);
  }
}